(function () {
	'use strict';

	angular.module('smb-app')
		.factory('smbDocumentHistoryService', [
			'$http',
			'$q',
			'gettextCatalog',
			'pxUriPathService',
			DocumentHistoryService
		]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbDocumentNotesService
	 * 
	 * @description
	 * Exposes methods for retrieving and creating document notes.
	 */
	function DocumentHistoryService($http, $q, gettextCatalog, pxUriPathService) {

		return {
			/**
			 * @ngdoc method
			 * @name smbDocumentNotesService#getNotes
			 * @methodOf smb-app.smbDocumentNotesService
			 * @kind function
			 * 
			 * @description
			 * Gets the collection of all notes for a document
			 * 
			 * @param {String} documentId Id of the document whose notes are being retrieved.
			 *
			 * @returns {Deferred<DocumentNote>} A promise that resolves to a collection of @see DocumentNote objects
			 */
			getHistory: getHistory

		};

		function getHistory(documentId) {
			if (!documentId) {
				return $q.reject(new Error(gettextCatalog.getString('Missing required document id')));
			}

			var uri = '/documents/' + documentId + '/activities?top=-1&descend=false';
			return $http.get(pxUriPathService.resolvePath(uri))
				.then(function(response) {
					return response.data;
				});
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/services/documentHistoryService.js
// module id = 149
// module chunks = 1